import { render, staticRenderFns } from "./threejs8.vue?vue&type=template&id=45fa5383&scoped=true"
import script from "./threejs8.vue?vue&type=script&lang=js"
export * from "./threejs8.vue?vue&type=script&lang=js"
import style0 from "./threejs8.vue?vue&type=style&index=0&id=45fa5383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa5383",
  null
  
)

export default component.exports